module.exports = __webpack_public_path__ + "7ed6b8efd9faa33647f8b6012da92c85.png";